httpVueLoader.register(Vue, 'components/contact.vue');
httpVueLoader.register(Vue, 'components/WB00324901/Wb00324901.vue');

const store = new Vuex.Store({
    state: {
        result: null,
    },
    mutations: {
        setData(state, payload) {
            state.result = payload;
        },
    },
    actions: {
        getData(context) {
            axios.get('db.json').then(res => {
                context.commit('setData', res.data);
            });
        },
    }
});

new Vue({
    el: 'main',
    computed: {
        result() {
            return store.state.result;
        },
    },
    methods: {
    },
    created() {
        store.dispatch('getData');
    },
    mounted() {
        $('.page-submenubox .page-submenu .container .tel').empty();
        $('.page-submenubox .page-submenu .container .tel').html(`<img src="https://static.digiwin.com/tw/static/images/tel.png">免費諮詢熱線：0809-088-958`)
    },
});